import { applicationBase, applicationPaths } from "shared/static/paths.ts.erb";
import { pathify } from "shared/utils/pathify";

export const pathTemplates = {
  application: {
    base: applicationBase,
    paths: pathify(applicationBase, applicationPaths),
  },
};
